import React, { useContext, useState } from 'react';
import Switch from 'react-switch';
import BookerShortContext from '../../context/bookerShortContext';
import BookerContext from '../../context/bookerContext';
import FetchService from '../../services/fetchService';
import urlService from '../../services/urlService';
import { mixpanelEventTrack, registerMixpanelEvent } from '../../services/mixpanel';

const ToggleSMSNotification = () => {
  const context = useContext(BookerContext);
  const {
    state: { userProfile, isWebBooker },
    updateUserProfile,
  } = context;
  const shortContext = useContext(BookerShortContext);
  const { togglePopup } = shortContext;
  const { sms_enabled } = userProfile;
  const [checked, setChecked] = useState(sms_enabled);

  const disableNotifications = () => {
    FetchService.getWebApiResource(urlService.updateProfileSms(false))
      .then(response => {
        console.log(response);
        mixpanelEventTrack(isWebBooker ? 'smsDisabledWebBook' : 'smsDisabled');
        updateUserProfile({ ...userProfile, sms_enabled: false });
      })
      .catch(error => {
        console.log('sms disabled error');
      });
    togglePopup(false, 'manageSmsNotificationMenu');
  };

  const cancelDisable = () => {
    setChecked(true);
    updateUserProfile({ ...userProfile, sms_enabled: true });
    togglePopup(false, 'manageSmsNotificationMenu');
  };

  const handleChange = nextChecked => {
    setChecked(nextChecked);
    if (!nextChecked) {
      togglePopup(true, 'manageSmsNotificationMenu', [
        { textBtn: 'Disable Notifications', clickHandler: disableNotifications },
        { textBtn: 'Cancel', clickHandler: cancelDisable },
      ]);
    } else {
      FetchService.getWebApiResource(urlService.updateProfileSms(true))
        .then(response => {
          console.log(response);
          mixpanelEventTrack(isWebBooker ? 'smsEnabledWebBook' : 'smsEnabled');
          updateUserProfile({ ...userProfile, sms_enabled: true });
        })
        .catch(error => {
          console.log('sms enabled error');
        });
    }
  };

  return (
    <Switch
      onChange={handleChange}
      checked={checked}
      className="react-switch"
      onColor="#a4ddcc"
      onHandleColor="#16ad74"
      handleDiameter={20}
      uncheckedIcon={false}
      checkedIcon={false}
      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0)"
      height={10}
      width={30}
    />
  );
};

export default ToggleSMSNotification;
